import React from 'react';
import { Moon, Activity, RefreshCw, Minimize2, Check } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function SolutionSection() {
  const benefits = [{
    icon: Moon,
    text: 'Resetear tu sueño'
  }, {
    icon: Minimize2,
    text: 'Bajar el cortisol'
  }, {
    icon: Activity,
    text: 'Activar tu metabolismo'
  }, {
    icon: RefreshCw,
    text: 'Empezar a desinflamar la barriga'
  }];
  const results = ['Duermes sin despertarte', 'Te levantas con energía', 'Tu barriga deja de inflamarse'];
  return <section className="py-24 bg-white relative" data-id="element-212">
      <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-213">
        <FadeIn data-id="element-214">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-4" data-id="element-215">
            Esto es lo que cambia cuando aplicas el sistema:
          </h2>
          <p className="text-lg md:text-xl text-charcoal-light mb-16" data-id="element-216">
            Estos cambios no son milagros. Son lo que ocurre cuando tu cuerpo
            vuelve a funcionar como debería.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-217">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <FadeIn key={index} delay={index * 0.1} data-id="element-218">
                <div className="bg-cream p-8 rounded-2xl shadow-card border border-cream-dark/30 flex items-center gap-6 group hover:shadow-card-hover transition-shadow" data-id="element-219">
                  <div className="bg-white p-4 rounded-xl shadow-warm-sm text-terracotta group-hover:scale-110 transition-transform duration-300" data-id="element-220">
                    <Icon className="w-8 h-8" strokeWidth={2} data-id="element-221" />
                  </div>
                  <h3 className="text-xl font-bold text-charcoal text-left" data-id="element-222">
                    {benefit.text}
                  </h3>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.5} data-id="element-223">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-16" data-id="element-224">
            {results.map((result, index) => <div key={index} className="flex items-center gap-3" data-id="element-225">
                <div className="w-6 h-6 rounded-full bg-terracotta/10 flex items-center justify-center" data-id="element-226">
                  <Check className="w-4 h-4 text-terracotta" strokeWidth={3} data-id="element-227" />
                </div>
                <span className="text-lg font-bold text-charcoal" data-id="element-228">
                  {result}
                </span>
              </div>)}
          </div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-229">
          <CTAButton data-id="element-230" />
        </FadeIn>
      </div>
    </section>;
}